module.exports = __webpack_public_path__ + "static/img/index_active.71010556.svg";